import { STORE_EVENTS } from '@/constants/storeEvents'
import {
  eventTimestamp,
  trackStoreEvent,
  trackStoreEventOnce
} from '@/utils/storeEvents.utils'

// `status` of STORE_STATUS_CHANGE, capitalised as the mobile apps send it.
export const STORE_STATUS = {
  ONLINE: 'Online',
  BUSY: 'Busy',
  OFFLINE: 'Offline'
} as const

export type StoreStatus = typeof STORE_STATUS[keyof typeof STORE_STATUS]

/**
 * Report that a store (or a branch) is now Online, Busy or Offline. Call it
 * once the API confirmed the change. With `dedupeId`, only the first call for
 * that id is sent (every open tab runs the busy auto-expiry timer, so each
 * would otherwise report the same expiry).
 */
export function trackStoreStatusChange(
  store: { storeId?: string | null; storeName?: string | null },
  status: StoreStatus,
  dedupeId?: string
): void {
  const params = {
    store_id: store.storeId,
    store_name: store.storeName,
    status,
    timestamp: eventTimestamp()
  }

  if (dedupeId) {
    void trackStoreEventOnce(STORE_EVENTS.STATUS_CHANGE, dedupeId, params)
  } else {
    trackStoreEvent(STORE_EVENTS.STATUS_CHANGE, params)
  }
}
